import { ConfigProvider } from 'antd';
import koKR from 'antd/locale/ko_KR';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { AppRoutes } from './router';
import { AuthGate } from './AuthGate';
import { SessionProvider } from './SessionProvider';
import { CalibrationProvider } from './CalibrationProvider';
import { ApiContext } from './api-context';
import { createApiClient } from '../lib/api';
import { createQueryClient } from '../lib/queryClient';
import { firebaseSession } from '../lib/firebaseSession';

const queryClient = createQueryClient();
const api = createApiClient({ baseUrl: import.meta.env.VITE_ADMIN_API_BASE ?? '', getToken: firebaseSession.getIdToken });

export function App() {
  return (
    <ConfigProvider locale={koKR}>
      <SessionProvider session={firebaseSession}>
        <ApiContext.Provider value={api}>
          <QueryClientProvider client={queryClient}>
            <AuthGate>
              <CalibrationProvider>
                <BrowserRouter>
                  <AppRoutes />
                </BrowserRouter>
              </CalibrationProvider>
            </AuthGate>
          </QueryClientProvider>
        </ApiContext.Provider>
      </SessionProvider>
    </ConfigProvider>
  );
}
